import React, { useState, useEffect } from "react";
import "../../static/css/Nivel4.css";
import { useParams, useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import axios from "../../utils/axios";
import useAuth from "../../hooks/useAuth";

const Nivel6 = (props) => {
  const { data } = props;
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [SaltoElemento1, setSaltoElemento1] = useState("");
  const [SaltoElemento2, setSaltoElemento2] = useState("");
  const [SaltoElemento3, setSaltoElemento3] = useState("");
  const [BarraElemento1, setBarraElemento1] = useState("");
  const [BarraElemento2, setBarraElemento2] = useState("");
  const [BarraElemento3, setBarraElemento3] = useState("");
  const [BarraElemento4, setBarraElemento4] = useState("");
  const [BarraElemento5, setBarraElemento5] = useState("");
  const [BarraElemento6, setBarraElemento6] = useState("");
  const [VigaElemento1, setVigaElemento1] = useState("");
  const [VigaElemento2, setVigaElemento2] = useState("");
  const [VigaElemento3, setVigaElemento3] = useState("");
  const [VigaElemento4, setVigaElemento4] = useState("");
  const [VigaElemento5, setVigaElemento5] = useState("");
  const [VigaElemento6, setVigaElemento6] = useState("");
  const [PisoElemento1, setPisoElemento1] = useState("");
  const [PisoElemento2, setPisoElemento2] = useState("");
  const [PisoElemento3, setPisoElemento3] = useState("");
  const [PisoElemento4, setPisoElemento4] = useState("");
  const [PisoElemento5, setPisoElemento5] = useState("");
  const [PisoElemento6, setPisoElemento6] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `/api/atleta/info/nivel6/`,
        JSON.stringify({
          NumSocio: data.NumSocio,
          SaltoElemento1: SaltoElemento1,
          SaltoElemento2: SaltoElemento2,
          SaltoElemento3: SaltoElemento3,
          BarraElemento1: BarraElemento1,
          BarraElemento2: BarraElemento2,
          BarraElemento3: BarraElemento3,
          BarraElemento4: BarraElemento4,
          BarraElemento5: BarraElemento5,
          BarraElemento6: BarraElemento6,
          VigaElemento1: VigaElemento1,
          VigaElemento2: VigaElemento2,
          VigaElemento3: VigaElemento3,
          VigaElemento4: VigaElemento4,
          VigaElemento5: VigaElemento5,
          VigaElemento6: VigaElemento6,
          PisoElemento1: PisoElemento1,
          PisoElemento2: PisoElemento2,
          PisoElemento3: PisoElemento3,
          PisoElemento4: PisoElemento4,
          PisoElemento5: PisoElemento5,
          PisoElemento6: PisoElemento6,
        }),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${auth.accessToken}`,
          },
        }
      );
      alert("Informacion actualizada correctamente!");
      navigate(-1);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <section className="NivelesBajos">
      <h3 className="Categoria">Categoria: Nivel 6</h3>
      <form onSubmit={handleSubmit} className="Calificaciones">
        <h4 className="TituloGrupo">Salto</h4>
        <div className="Elementos">
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 1:Voltereta frontal a la pila de colchonetas
            </h4>
            <input
              name="Elemento1Salto"
              type="text"
              className="CalificacionesInput"
              value={SaltoElemento1}
              onChange={(e) => setSaltoElemento1(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 2: 1/2 encendido (temporizador Tsuk) a la pila de tapetes
            </h4>
            <input
              name="Elemento2Salto"
              type="text"
              className="CalificacionesInput"
              value={SaltoElemento2}
              onChange={(e) => setSaltoElemento2(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4>
              Elemento 3: Temporizador Yurchenko (redondeo al tablero,
              <br />
              voltereta hacia atrás sobre la mesa) a la pila de tapetes
            </h4>
            <input
              name="Elemento3Salto"
              type="text"
              className="CalificacionesInput"
              value={SaltoElemento3}
              onChange={(e) => setSaltoElemento3(e.target.value)}
            />
          </div>
        </div>
        <h4 className="TituloGrupo">Barra</h4>
        <div className="Elementos">
          <div className="Elemento">
            <h4 className="TituloElemento">Elemento 1: Kipe</h4>
            <input
              name="Elemento1Barra"
              type="text"
              className="CalificacionesInput"
              value={BarraElemento1}
              onChange={(e) => setBarraElemento1(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 2: Despegue por encima de la horizontal
            </h4>
            <input
              name="Elemento2Barra"
              type="text"
              className="CalificacionesInput"
              value={BarraElemento2}
              onChange={(e) => setBarraElemento2(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">Elemento 3: CUARTA</h4>
            <input
              name="Elemento3Barra"
              type="text"
              className="CalificacionesInput"
              value={BarraElemento3}
              onChange={(e) => setBarraElemento3(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 4: 1 cambio de barra ¨Pollito ¨
            </h4>
            <input
              name="Elemento4Barra"
              type="text"
              className="CalificacionesInput"
              value={BarraElemento4}
              onChange={(e) => setBarraElemento4(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">Elemento 5: Kipe + vuelta atrás</h4>
            <input
              name="Elemento5Barra"
              type="text"
              className="CalificacionesInput"
              value={BarraElemento5}
              onChange={(e) => setBarraElemento5(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">Elemento 6: Salida de mortal</h4>
            <input
              name="Elemento6Barra"
              type="text"
              className="CalificacionesInput"
              value={BarraElemento6}
              onChange={(e) => setBarraElemento6(e.target.value)}
            />
          </div>
        </div>
        <h4 className="TituloGrupo">Viga</h4>
        <div className="Elementos">
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 1: Serie acrobática sin vuelo x2 <br />O 1 elemento de
              vuelo acrobático
            </h4>
            <input
              name="Elemento1Viga"
              type="text"
              className="CalificacionesInput"
              value={VigaElemento1}
              onChange={(e) => setVigaElemento1(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 2: Salto o salto de 180°
            </h4>
            <input
              name="Elemento2Viga"
              type="text"
              className="CalificacionesInput"
              value={VigaElemento2}
              onChange={(e) => setVigaElemento2(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 3: Mínimo 1/1 vuelta en un pie
            </h4>
            <input
              name="Elemento3Viga"
              type="text"
              className="CalificacionesInput"
              value={VigaElemento3}
              onChange={(e) => setVigaElemento3(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">Elemento 4: 1/2 LUNA</h4>
            <input
              name="Elemento4Viga"
              type="text"
              className="CalificacionesInput"
              value={VigaElemento4}
              onChange={(e) => setVigaElemento4(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">Elemento 5: ( split - sissone )</h4>
            <input
              name="Elemento5Viga"
              type="text"
              className="CalificacionesInput"
              value={VigaElemento5}
              onChange={(e) => setVigaElemento5(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 6: Un mortal/desmontaje aéreo
            </h4>
            <input
              name="Elemento6Viga"
              type="text"
              className="CalificacionesInput"
              value={VigaElemento6}
              onChange={(e) => setVigaElemento6(e.target.value)}
            />
          </div>
        </div>
        <h4 className="TituloGrupo">Piso</h4>
        <div className="Elementos">
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 1: Pase acro de 3 elementos, mínimo 2 elementos de vuelo
            </h4>
            <input
              name="Elemento1Piso"
              type="text"
              className="CalificacionesInput"
              value={PisoElemento1}
              onChange={(e) => setPisoElemento1(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 2: 2° pase acrobático incluyendo mortal o aéreo
            </h4>
            <input
              name="Elemento2Piso"
              type="text"
              className="CalificacionesInput"
              value={PisoElemento2}
              onChange={(e) => setPisoElemento2(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 3: Pasaje de baile (2 elementos del Grupo 1) que incluye
              un salto de 180° desde un pie
            </h4>
            <input
              name="Elemento3Piso"
              type="text"
              className="CalificacionesInput"
              value={PisoElemento3}
              onChange={(e) => setPisoElemento3(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 4: Mínimo 1/1 vuelta en un pie
            </h4>
            <input
              name="Elemento4Piso"
              type="text"
              className="CalificacionesInput"
              value={PisoElemento4}
              onChange={(e) => setPisoElemento4(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">
              Elemento 5: 2° elemento del pasaje de baile
            </h4>
            <input
              name="Elemento5Piso"
              type="text"
              className="CalificacionesInput"
              value={PisoElemento5}
              onChange={(e) => setPisoElemento5(e.target.value)}
            />
          </div>
          <div className="Elemento">
            <h4 className="TituloElemento">Elemento 6: Elemento "B"</h4>
            <input
              name="Elemento6Piso"
              type="text"
              className="CalificacionesInput"
              value={PisoElemento6}
              onChange={(e) => setPisoElemento6(e.target.value)}
            />
          </div>
        </div>
        <input type="submit" className="button" value="Actualizar" />
      </form>
    </section>
  );
};

export default Nivel6;
